import { NonQualifyingAdverb } from '../../types'

const нахуй: NonQualifyingAdverb = {
  type: 'non qualifying adverb',
  adverb: 'нахуй',
}

export default нахуй
